const BUTTON_HEIGHT = 60;
const MOBILE_BUTTON_HEIGHT = 46;
const SUMMARY_BAR_HEIGHT = 60;
const MOBILE_SUMMARY_BAR_HEIGHT = 50;
const SIDE_WIDTH = 440;
const NAV_BAR_HEIGHT = 50;
const MOBILE_NAV_BAR_HEIGHT= 35;
const HEADER_HEIGHT = 80;
const MOBILE_HEADER_HEIGHT = 100;
const APP_HEADER_HEIGHT = 88;
const IMAGE_SIDEBAR_GAP = 1;

export default {
  BUTTON_HEIGHT,
  BUTTON_HEIGHT_PX: `${BUTTON_HEIGHT}px`,
  MOBILE_BUTTON_HEIGHT: `${MOBILE_BUTTON_HEIGHT}`,
  MOBILE_BUTTON_HEIGHT_PX: `${MOBILE_BUTTON_HEIGHT}px`,

  SIDE_WIDTH,
  SIDE_WIDTH_PX: `${SIDE_WIDTH}px`,

  NAV_BAR_HEIGHT,
  NAV_BAR_HEIGHT_PX: `${NAV_BAR_HEIGHT}px`,
  MOBILE_NAV_BAR_HEIGHT_PX: `${MOBILE_NAV_BAR_HEIGHT}px`,

  HEADER_HEIGHT,
  HEADER_HEIGHT_PX: `${HEADER_HEIGHT}px`,

  MOBILE_HEADER_HEIGHT,
  MOBILE_HEADER_HEIGHT_PX: `${MOBILE_HEADER_HEIGHT}px`,

  SUMMARY_BAR_HEIGHT: `${SUMMARY_BAR_HEIGHT}`,
  SUMMARY_BAR_HEIGHT_PX: `${SUMMARY_BAR_HEIGHT}px`,
  MOBILE_SUMMARY_BAR_HEIGHT: `${MOBILE_SUMMARY_BAR_HEIGHT}`,
  MOBILE_SUMMARY_BAR_HEIGHT_PX: `${MOBILE_SUMMARY_BAR_HEIGHT}px`,

  APP_HEADER_HEIGHT_PX: `${APP_HEADER_HEIGHT}px`,

  IMAGE_SIDEBAR_GAP_PX: `${IMAGE_SIDEBAR_GAP}px`
}
